/* A workaround For Raphael Inability to Maintain Constant Stroke Width When Drawing Rectangles */
// $(this.el.node).attr('vector-effect', 'non-scaling-stroke'); won't work with older browsers
//also turns on/off the stroke of the main el

var Raphael = require('raphael');
require('extendRaphael');

var BORDER = function(raphaelEl) {

    this.raphaelEl = raphaelEl;
    this.osw = raphaelEl.attr('stroke-width');
    this.oStroke = raphaelEl.attr('stroke');

    raphaelEl.attr('stroke-width', 0);

    this.shape = raphaelEl.paper.path( raphaelEl.getPathOfBBox() ).attr({
        'stroke-width': this.osw,
        fill: 'none',
        stroke: this.oStroke
    }).toBack();

    return this;

};

_.extend(BORDER.prototype, {
    move: function() {
        this.shape.attr( 'path', this.raphaelEl.getPathOfBBox() ).attr({
            'stroke-width': this.osw,
            stroke: this.oStroke
        });
        return this;
    },
    hide: function() {
      this.shape.hide();
      return this;
    },
    show: function() {
        this.shape.show();
        return this;
    },
    destroy: function(resetShapeAttrs)  {
        this.shape.remove();
        if (resetShapeAttrs) { //don't need for new (drawn)
            this.raphaelEl.attr({
                'stroke-width': this.osw,
                stroke: this.oStroke
            });
        }
        return this;
    }
});


module.exports = BORDER;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/helper/dummyRectBorder.js
 ** module id = 199
 ** module chunks = 0
 **/